export const UNDO = 'UNDO';

export const UndoAction = (): any => {
  return {
    type: UNDO,
  };
};
